import { render } from "./RackLotForm.vue?vue&type=template&id=87aabf66"
import script from "./RackLotForm.vue?vue&type=script&lang=js"
export * from "./RackLotForm.vue?vue&type=script&lang=js"
script.render = render

export default script